import { ActionsCell } from "../../../../Component/Common/Components/DataTable/ActionsCell";
import { DefaultCell } from "../../../../Component/Common/Components/DataTable/DefaultCell";
import { PeopleDtos } from "../../../../Component/Model/Dto/People";
import { DateFormatter, employeeTypeFormatter, occupationLevelFormatter } from "../../../../Component/Model/helpers";
import { ActionType, TableColumn } from "../../../../Component/Model/Table/Table";

interface IPositionsDataRows extends Omit<PeopleDtos.GetPersonEmploymentRequest, "employeeTypeId" |"startDate" |"endDate"|"occupationalLevelId" | "isPermanent"> {
    occupationalLevelId: string;
    employeeTypeId: string;
    isPermanent: string;
    startDate: string | undefined;
    endDate: string | undefined;
    Actions: ActionType[];
}


export interface IPositionsTable {
    columns: Array<TableColumn>;
    rows: Array<IPositionsDataRows>;
}

export function PositionsDataTableMapper(results: PeopleDtos.GetPersonEmploymentRequest[], onEditEmploymenteRow: (personId: number,id: number) => void): IPositionsTable {
    const columns = [
        { Header: 'Level', accessor: 'occupationalLevelId', Cell: ({ value }: any) => <DefaultCell value={value} />},
        { Header: 'Position', accessor: 'positionName', Cell: ({ value }: any) => <DefaultCell value={value} />},
        { Header: 'Employee Status', accessor: 'employeeTypeId', Cell: ({ value }: any) => <DefaultCell value={value} />},
        { Header: 'OFO Code', accessor: 'ofoCode', Cell: ({ value }: any) => <DefaultCell value={value} />},
        { Header: 'Permanent', accessor: 'isPermanent', Cell: ({ value }: any) => <DefaultCell value={value} />},
        { Header: 'Start Date', accessor: 'startDate', Cell: ({ value }: any) => <DefaultCell value={value} />},
        { Header: 'End Date', accessor: 'endDate', Cell: ({ value }: any) => <DefaultCell value={value} />},
        { Header: 'Actions', accessor: 'Actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true },
    ];

    if (results.length >= 0) {
        const rows = results.map((item: PeopleDtos.GetPersonEmploymentRequest, index: number) => (
            {
                ...item,
                occupationalLevelId: occupationLevelFormatter(item.occupationalLevelId),
                employeeTypeId: employeeTypeFormatter(item.employeeTypeId),
                isPermanent: item.isPermanent === true ? "Yes": " No",
                startDate: item.startDate ? DateFormatter(item.startDate.toString()): "Unspecified",
                endDate: item.endDate ? DateFormatter(item.endDate.toString()) : "Current",
                Actions: [
                    {
                        key: index.toString(),
                        label: 'Edit',
                        action: () => {
                            onEditEmploymenteRow(item.personId,item.id);
                        },
                        icon: {
                            color: 'info',
                            name: 'edit'
                        }
                    },
                ]
            }));

        return { columns: columns, rows: rows };
    }else{
        return { columns: columns, rows: [] };
    }
}